// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"GuestCustomerOnboardingForm_modalFooter__6p7zU","alert":"GuestCustomerOnboardingForm_alert__OCtg_"};